// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/img/login-img-001.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-list-group-active-hover-theme: #0b13545a !important;
  --bs-list-group-active-bg-theme: #0b1354 !important;
}

body {
  color: #475259 !important;
  font-size: 14px;
}

.content-wrapper {
  background-color: #ffffff;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

label.form-label {
  font-weight: 300 !important;
}

a {
  text-decoration: none;
}

.nav-treeview a.nav-link {
  width: 90% !important;
  font-size: 15px !important;
  margin-left: 22px !important;
}

#ascene-container {
  height: 800px;
}

.nav-pills .nav-link:not(.active):hover {
  color: #c2c7d0;
  background: #4b4b4b;
}

.table-hover tr:hover {
  cursor: pointer;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 800px;
  padding: 10px 5px;
}

.chat-message-container {
  flex: 1 1;
  overflow: auto;
}

.chat-input-container {
  height: auto;
  padding: 0px 5px;
}

.chat-input-form {
  border: none;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
}

.chat-input-form:focus {
  outline: none;
}

.chat-header-container {
  height: auto;
}

.card.full {
  max-height: 800px;
  min-height: 800px;
  overflow: auto;
}

.chat-header-container {
  height: auto;
  background: #0b1354;
  padding: 10px;
}

.chat-header-container .title {
  color: #fff;
  font-size: 16px;
  margin: 0;
}

.chat-header-container .description {
  color: #fff;
  font-size: 12px;
  margin: 0;
}

.chat-message-container .assistant {
  background: #0b1354;
  color: #fff;
  border-radius: 5px;
  padding: 7px 10px;
  max-width: 75%;
  width: fit-content;
  margin-bottom: 5px;
}

.chat-message-container .user {
  background: #fff;
  color: #0b1354;
  border-radius: 5px;
  padding: 7px 15px;
  max-width: 75%;
  float: right;
  margin-top: 1rem;
  border: 1px solid #0b1354;
  margin-right: 5px;
}

.badge.text-bg-primary {
  background-color: #0b1354 !important;
}

.appearance-ui .assistant {
  background: #0b1354;
  color: #fff;
  border-radius: 5px;
  padding: 7px 10px;
  max-width: 75%;
  width: fit-content;
}

.appearance-ui .user {
  background: #fff;
  color: #0b1354;
  border-radius: 5px;
  padding: 7px 15px;
  width: fit-content;
  max-width: 75%;
  border: 1px solid #0b1354;
  margin-right: 5px;
}

.appearance-ui .suggestion {
  background: #fff;
  color: #0b1354;
  border-radius: 5px !important;
  padding: 7px 15px;
  max-width: 75%;
  width: fit-content;
  border: 1px solid #0b1354;
  margin-right: 5px;
}

.input-group-text {
  font-size: 14px;
  border-radius: 0px;
}

.chat-message-container li {
  display: inline-block;
  width: 100%;
}

.chat-message-container ul {
  padding-left: 0;
}

.chat-message-container .badge {
  line-height: 16px;
}

.card {
  box-shadow: none;
  border: 1px solid #fff;
  border-radius: 5px;
}

.main-header {
  border-bottom: 1px solid #ececec;
}

li.list-group-item {
  border: none;
  border-bottom: 1px solid #ececec !important;
}

.list-group-item-action {
  cursor: pointer;
}

p.user.reverse {
  float: left;
}

p.assistant.reverse {
  float: right;
}

.massage-analysis-header {
  display: flex;
}

.massage-analysis-header .select {
  flex: 1 1;
}

.center-hv {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  /* padding-top: 100px; */
}

.center-hv p.header {
  margin-bottom: 0;
  font-weight: 600;
  color: #626262;
}

.center-hv p.content {
  margin-bottom: 0;
  font-weight: 300;
  color: #626262;
  width: 80%;
  text-align: center;
  margin-top: 10px;
}

a.nav-link.active {
  background: #0b1354 !important;
  color: #fff !important;
}

a.nav-link {
  cursor: pointer;
}

a.nav-link:hover {
  background: #0b13542e;
}

/* .navbar-collapse {
  border-bottom: solid 1px #efefef;
  padding-bottom: 5px;
} */

/* Scroll Bar Design */
::-webkit-scrollbar-track {
  background-color: #ffffff;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #0b1354;
}

input[type="checkbox"] {
  accent-color: #f13776 !important;
}

.form-check-input:checked {
  background-color: #0b1354;
  border-color: #0b1354;
}

::-webkit-scrollbar-thumb {
  background-color: #0b1354;
  border: 2px solid #0b1354;
}

/* Login */
#login-page img {
  width: 100%;
}

#login-page .login {
  height: 1000px;
  width: 100%;
  background: radial-gradient(#653d84, #332042);
  position: relative;
}

#login-page .login_box {
  width: 1050px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 1px 4px 22px -8px #0004;
  display: flex;
  overflow: hidden;
}

#login-page .login_box .left {
  width: 41%;
  height: 100%;
  padding: 25px 25px;

}

#login-page .login_box .right {
  width: 59%;
  height: 100%
}

#login-page .left .top_link a {
  color: #452A5A;
  font-weight: 400;
}

#login-page .left .top_link {
  height: 20px
}

#login-page .left .contact {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  height: 100%;
  width: 73%;
  margin: auto;
}

#login-page .left h3 {
  text-align: center;
  margin-bottom: 40px;
}

#login-page .left input {
  border: none;
  width: 80%;
  margin: 15px 0px;
  border-bottom: 1px solid #4f30677d;
  padding: 7px 9px;
  width: 100%;
  overflow: hidden;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
}

#login-page .left {
  background: linear-gradient(-45deg, #dcd7e0, #fff);
}

#login-page .submit {
  border: none;
  padding: 15px 70px;
  border-radius: 8px;
  display: block;
  margin: auto;
  margin-top: 120px;
  background: #0b1354;
  color: #fff;
  font-weight: bold;
  box-shadow: 0px 9px 15px -11px rgba(88, 54, 114, 1);
}

.form-control,
.form-select {
  font-size: 14px;
  border-radius: 5px;
  padding: 10px 15px;
}

.form-control:focus,
.form-select:focus {
  box-shadow: none;
  border-color: #0b1354;
}

button.btn.btn-link {
  color: #0b1354;
  text-decoration: none;
  font-size: 14px;
}

button.btn.btn-link:active {
  color: #0b1354;
}

.suggestion-btn {
  background: #fff;
  color: #0b1354;
  border-radius: 5px;
  padding: 7px 15px;
  max-width: 75%;
  float: right;
  margin-top: 5px;
  border: 1px solid #0b1354;
  margin-right: 5px;
}

li.suggestion-list-container {
  width: 85%;
  float: right;
  padding-bottom: 15px;
}

.suggestion-btn:hover {
  background: #0b1354;
  color: #fff;
}

.accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #0b1354;
}

.accordion-button:focus {
  box-shadow: none;
}

.chat-message-container li:first-child {
  margin-top: 10px;
}

.suggestion-list-container p {
  text-align: right;
  margin: 0;
  margin-top: 15px;
  font-size: 15px;
  font-weight: 500;
  margin-right: 10px;
}


#login-page .right {
  background: linear-gradient(212.38deg, rgba(242, 57, 127, 0.7) 0%, rgba(175, 70, 189, 0.71) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: #fff;
  position: relative;
}

#login-page .right .right-text {
  height: 100%;
  position: relative;
  transform: translate(0%, 45%);
}

#login-page .right-text h3 {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
}

#login-page .right-text h5 {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 19px;
  font-weight: 400;
}

#login-page .right .right-inductor {
  position: absolute;
  width: 70px;
  height: 7px;
  background: #fff0;
  left: 50%;
  bottom: 70px;
  transform: translate(-50%, 0%);
}

#login-page .top_link img {
  width: 28px;
  padding-right: 7px;
  margin-top: -3px;
}

[class*=sidebar-dark-] .nav-header {
  background-color: inherit;
  color: #475259;
}

[class*=sidebar-dark-] .sidebar a {
  color: #475259;
  font-size: 14px;
  font-weight: 500;
}

[class*=sidebar-dark-] {
  background-color: #ffffff;
}

[class*=sidebar-dark] .brand-link,
[class*=sidebar-dark] .brand-link .pushmenu {
  color: #475259;
}

[class*=sidebar-dark] .brand-link .pushmenu:hover,
[class*=sidebar-dark] .brand-link:hover {
  color: #475259;
}

[class*=sidebar-dark] .brand-link {
  border-bottom: none;
}

.elevation-4 {
  box-shadow: 0 0px 0px rgba(0, 0, 0, .25), 0 0px 5px rgba(0, 0, 0, .22) !important;
}

.sidebar {
  padding-left: 0px;
}

.brand-link .brand-image {
  float: unset;
  line-height: .8;
  margin-left: 0.8rem;
  margin-right: 0.5rem;
  margin-top: -3px;
  max-height: 50px;
  width: auto;
}

.nav-pills .nav-link:not(.active):hover {
  color: #0b1354;
  background: #e7e7e7;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #0b1354;
  background-color: #0b135428;
}

.nav-pills .nav-link {
  border-radius: 0px 20px 20px 0px !important;
}

table {
  color: #475259 !important;
  font-size: 14px;
}

.btn.btn-primary,
.btn.btn-success,
.btn-outline-primary:hover,
.btn-outline-primary:not(:disabled):not(.disabled):active {
  background: #0b1354;
  border-color: unset;
}

.btn-outline-primary {
  border-color: #0b1354;
  color: #0b1354;
}

.btn {
  border-radius: 20px;
  padding: 5px 25px;
}

.bg-primary {
  background-color: #0b1354 !important;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0b1354;
  border-color: #0b1354;
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, .075);
}

.table-hover>tbody>tr:hover>* {
  color: #0b1354;
}

.table thead th {
  background-color: #fff;
  color: #0b1354;
}

.btn.btn-danger {
  background: #f13776;
  border-color: unset;
}

.login img.brand-image {
  width: 50% !important;
}

.form-container {
  text-align: center;
}

p.error {
  color: #d70149;
}

p.error.hide {
  display: none;
}

.form-group {
  padding: 15px 10px;
  border: 1px solid #f4f6f9;
  border-radius: 10px;
}

.main-sidebar {
  height: 100vh !important;
}


.thread {
  padding: 15px 5px;
}

#records-page .container-fluid {
  background: #fff;
}

.border-b {
  border-bottom: 1px solid #efefef;
}

.border-t {
  border-top: 1px solid #efefef;
}

.border-r {
  border-right: 1px solid #efefef;
}

.border-l {
  border-left: 1px solid #efefef;
}

.thread {
  pointer-events: none;
}

.thread-message.assistant {
  background: #c0c0c05c;
}

.thread-message {
  padding: 5px 10px;
  margin-bottom: 15px;
}

.tab-nav .nav-link {
  color: #475258;
  font-weight: 600;
}

.tab-nav .nav-link:hover {
  color: #0b1354;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.twitter-picker {
  box-shadow: unset !important;
}

/* File Uploader Dropper */
.upload-drop-file svg {
  display: none !important;
}

.upload-drop-file {
  border: 2px dashed rgb(11 19 84 / 24%) !important;
  border-radius: 3px !important;
  width: 100% !important;
    max-width: 100% !important;
}

table.table {
  border-radius: 10px !important;
  overflow: hidden;
}

/* custom nav bar */
/* Round Switch Nav Bar */

.round-nav a.nav-link {
  border-radius: 24px;
  padding: 5px 25px !important;
  margin-right: 2px;
}

.round-nav .border {
  border: 1px solid #0b1354 !important;
}

.round-nav .navbar-nav {
  padding: 5px 7px;
  border-radius: 40px;
}

.navbar>.container-fluid.center {
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.card-title {
  float: unset;
}

/* Table Custom Design */
.table-expand-container {
  padding: 10px 45px;
}

.table-expand-container .prompt {
  margin-bottom: 2px;
  font-weight: bold;
}

input.form-control.invalid {
  border-color: #ee5e3f;
}

.appearance-image-container {
  min-height: 250px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 3px #c6c3c3 dotted;
  border-radius: 5px;
}

/* EDITOR JS Style */
.prompt-text-editor {
  border: 1px solid #dee2e6;
  border-radius: 20px;
  padding: 10px 15px;
}

.cdx-input.embed-tool__caption,
.inline-image .cdx-input:not([id]) {
  display: none;
}

iframe.embed-tool__content {
  width: 100%;
  border-radius: 10px;
  height: 30vh !important;
  min-height: unset !important;
  max-height: unset !important;
  background: #fff;
}

/* REACT DATE RANGE */
.rdrDateRangePickerWrapper {
  position: absolute;
  z-index: 9;
  width: 100%;
  padding: 0;
  margin-top: 5px;
}

/* Chart Style */
.text-report p.label {
  margin: 0;
  font-size: 12px;
}

.text-report p.value {
  text-align: center !important;
  font-size: 35px;
  font-weight: 900;
}

.thread-message img {
  width: 100%;
  height: fit-content;
}

b,
strong {
  text-transform: capitalize;
}

.badge {
  text-transform: capitalize;
}

.input-prompt textarea {
  width: 100%;
  height: 50px;
  border: unset;
  border-radius: 5px;
  resize: none;
  padding: 12px;
}

.input-prompt textarea:focus-visible {
  outline: unset
}

#create-analysis-report .input-prompt {
  padding: 5px;
  border: solid 1px #0b135542;
  border-radius: 5px;
}

img.img-assist {
  width: 100%;
}

.list-group.menu {
  width: 100%;
  padding: 0px 8px;
}

.list-group.menu button.list-group-item {
  border: 0;
  font-weight: 700;
  border-radius: 10px;
}

.list-group.menu button.list-group-item.active {
  background-color: var(--bs-list-group-active-bg-theme);
}

.list-group.menu button.list-group-item:hover {
  background-color: var(--bs-list-group-active-hover-theme);
}

.ca-result-container p {
  margin-bottom: 20px !important;
  font-size: 16px;
  font-weight: 400;
}


.ca-result-container {
  max-height: 90vh;
  overflow: auto;
  height: 90vh;
  padding-bottom: 15%;
}

.ca-input-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  background: #fff;
}


#create-analysis-report img {
  width: 100%;
}

.js-plotly-plot {
  width: 100%;
}


#create-analysis-report table {
  border-collapse: collapse;
  width: 100%;
}

#create-analysis-report table  th,
#create-analysis-report table  td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}

/* body > iframe {
  display: none;
} */

#custom-data-analysis .list-group {
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wDAAwD;EACxD,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EAGjB,mDAAmD;AACrD;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,0IAA8I;EAC9I,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;AAC1B;;AAEA;EACE,iDAAiD;EACjD,6BAA6B;EAC7B,sBAAsB;IACpB,0BAA0B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB,yBAAyB;;AAEzB;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf","sourcesContent":[":root {\n  --bs-list-group-active-hover-theme: #0b13545a !important;\n  --bs-list-group-active-bg-theme: #0b1354 !important;\n}\n\nbody {\n  color: #475259 !important;\n  font-size: 14px;\n}\n\n.content-wrapper {\n  background-color: #ffffff;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\nlabel.form-label {\n  font-weight: 300 !important;\n}\n\na {\n  text-decoration: none;\n}\n\n.nav-treeview a.nav-link {\n  width: 90% !important;\n  font-size: 15px !important;\n  margin-left: 22px !important;\n}\n\n#ascene-container {\n  height: 800px;\n}\n\n.nav-pills .nav-link:not(.active):hover {\n  color: #c2c7d0;\n  background: #4b4b4b;\n}\n\n.table-hover tr:hover {\n  cursor: pointer;\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 800px;\n  padding: 10px 5px;\n}\n\n.chat-message-container {\n  flex: 1;\n  overflow: auto;\n}\n\n.chat-input-container {\n  height: auto;\n  padding: 0px 5px;\n}\n\n.chat-input-form {\n  border: none;\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n}\n\n.chat-input-form:focus {\n  outline: none;\n}\n\n.chat-header-container {\n  height: auto;\n}\n\n.card.full {\n  max-height: 800px;\n  min-height: 800px;\n  overflow: auto;\n}\n\n.chat-header-container {\n  height: auto;\n  background: #0b1354;\n  padding: 10px;\n}\n\n.chat-header-container .title {\n  color: #fff;\n  font-size: 16px;\n  margin: 0;\n}\n\n.chat-header-container .description {\n  color: #fff;\n  font-size: 12px;\n  margin: 0;\n}\n\n.chat-message-container .assistant {\n  background: #0b1354;\n  color: #fff;\n  border-radius: 5px;\n  padding: 7px 10px;\n  max-width: 75%;\n  width: fit-content;\n  margin-bottom: 5px;\n}\n\n.chat-message-container .user {\n  background: #fff;\n  color: #0b1354;\n  border-radius: 5px;\n  padding: 7px 15px;\n  max-width: 75%;\n  float: right;\n  margin-top: 1rem;\n  border: 1px solid #0b1354;\n  margin-right: 5px;\n}\n\n.badge.text-bg-primary {\n  background-color: #0b1354 !important;\n}\n\n.appearance-ui .assistant {\n  background: #0b1354;\n  color: #fff;\n  border-radius: 5px;\n  padding: 7px 10px;\n  max-width: 75%;\n  width: fit-content;\n}\n\n.appearance-ui .user {\n  background: #fff;\n  color: #0b1354;\n  border-radius: 5px;\n  padding: 7px 15px;\n  width: fit-content;\n  max-width: 75%;\n  border: 1px solid #0b1354;\n  margin-right: 5px;\n}\n\n.appearance-ui .suggestion {\n  background: #fff;\n  color: #0b1354;\n  border-radius: 5px !important;\n  padding: 7px 15px;\n  max-width: 75%;\n  width: fit-content;\n  border: 1px solid #0b1354;\n  margin-right: 5px;\n}\n\n.input-group-text {\n  font-size: 14px;\n  border-radius: 0px;\n}\n\n.chat-message-container li {\n  display: inline-block;\n  width: 100%;\n}\n\n.chat-message-container ul {\n  padding-left: 0;\n}\n\n.chat-message-container .badge {\n  line-height: 16px;\n}\n\n.card {\n  box-shadow: none;\n  border: 1px solid #fff;\n  border-radius: 5px;\n}\n\n.main-header {\n  border-bottom: 1px solid #ececec;\n}\n\nli.list-group-item {\n  border: none;\n  border-bottom: 1px solid #ececec !important;\n}\n\n.list-group-item-action {\n  cursor: pointer;\n}\n\np.user.reverse {\n  float: left;\n}\n\np.assistant.reverse {\n  float: right;\n}\n\n.massage-analysis-header {\n  display: flex;\n}\n\n.massage-analysis-header .select {\n  flex: 1;\n}\n\n.center-hv {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  flex-direction: column;\n  /* padding-top: 100px; */\n}\n\n.center-hv p.header {\n  margin-bottom: 0;\n  font-weight: 600;\n  color: #626262;\n}\n\n.center-hv p.content {\n  margin-bottom: 0;\n  font-weight: 300;\n  color: #626262;\n  width: 80%;\n  text-align: center;\n  margin-top: 10px;\n}\n\na.nav-link.active {\n  background: #0b1354 !important;\n  color: #fff !important;\n}\n\na.nav-link {\n  cursor: pointer;\n}\n\na.nav-link:hover {\n  background: #0b13542e;\n}\n\n/* .navbar-collapse {\n  border-bottom: solid 1px #efefef;\n  padding-bottom: 5px;\n} */\n\n/* Scroll Bar Design */\n::-webkit-scrollbar-track {\n  background-color: #ffffff;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  background-color: #0b1354;\n}\n\ninput[type=\"checkbox\"] {\n  accent-color: #f13776 !important;\n}\n\n.form-check-input:checked {\n  background-color: #0b1354;\n  border-color: #0b1354;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #0b1354;\n  border: 2px solid #0b1354;\n}\n\n/* Login */\n#login-page img {\n  width: 100%;\n}\n\n#login-page .login {\n  height: 1000px;\n  width: 100%;\n  background: radial-gradient(#653d84, #332042);\n  position: relative;\n}\n\n#login-page .login_box {\n  width: 1050px;\n  height: 600px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 1px 4px 22px -8px #0004;\n  display: flex;\n  overflow: hidden;\n}\n\n#login-page .login_box .left {\n  width: 41%;\n  height: 100%;\n  padding: 25px 25px;\n\n}\n\n#login-page .login_box .right {\n  width: 59%;\n  height: 100%\n}\n\n#login-page .left .top_link a {\n  color: #452A5A;\n  font-weight: 400;\n}\n\n#login-page .left .top_link {\n  height: 20px\n}\n\n#login-page .left .contact {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  height: 100%;\n  width: 73%;\n  margin: auto;\n}\n\n#login-page .left h3 {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n#login-page .left input {\n  border: none;\n  width: 80%;\n  margin: 15px 0px;\n  border-bottom: 1px solid #4f30677d;\n  padding: 7px 9px;\n  width: 100%;\n  overflow: hidden;\n  background: transparent;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n#login-page .left {\n  background: linear-gradient(-45deg, #dcd7e0, #fff);\n}\n\n#login-page .submit {\n  border: none;\n  padding: 15px 70px;\n  border-radius: 8px;\n  display: block;\n  margin: auto;\n  margin-top: 120px;\n  background: #0b1354;\n  color: #fff;\n  font-weight: bold;\n  -webkit-box-shadow: 0px 9px 15px -11px rgba(88, 54, 114, 1);\n  -moz-box-shadow: 0px 9px 15px -11px rgba(88, 54, 114, 1);\n  box-shadow: 0px 9px 15px -11px rgba(88, 54, 114, 1);\n}\n\n.form-control,\n.form-select {\n  font-size: 14px;\n  border-radius: 5px;\n  padding: 10px 15px;\n}\n\n.form-control:focus,\n.form-select:focus {\n  box-shadow: none;\n  border-color: #0b1354;\n}\n\nbutton.btn.btn-link {\n  color: #0b1354;\n  text-decoration: none;\n  font-size: 14px;\n}\n\nbutton.btn.btn-link:active {\n  color: #0b1354;\n}\n\n.suggestion-btn {\n  background: #fff;\n  color: #0b1354;\n  border-radius: 5px;\n  padding: 7px 15px;\n  max-width: 75%;\n  float: right;\n  margin-top: 5px;\n  border: 1px solid #0b1354;\n  margin-right: 5px;\n}\n\nli.suggestion-list-container {\n  width: 85%;\n  float: right;\n  padding-bottom: 15px;\n}\n\n.suggestion-btn:hover {\n  background: #0b1354;\n  color: #fff;\n}\n\n.accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #0b1354;\n}\n\n.accordion-button:focus {\n  box-shadow: none;\n}\n\n.chat-message-container li:first-child {\n  margin-top: 10px;\n}\n\n.suggestion-list-container p {\n  text-align: right;\n  margin: 0;\n  margin-top: 15px;\n  font-size: 15px;\n  font-weight: 500;\n  margin-right: 10px;\n}\n\n\n#login-page .right {\n  background: linear-gradient(212.38deg, rgba(242, 57, 127, 0.7) 0%, rgba(175, 70, 189, 0.71) 100%), url(../public/assets/img/login-img-001.jpg);\n  color: #fff;\n  position: relative;\n}\n\n#login-page .right .right-text {\n  height: 100%;\n  position: relative;\n  transform: translate(0%, 45%);\n}\n\n#login-page .right-text h3 {\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-size: 32px;\n  font-weight: 500;\n}\n\n#login-page .right-text h5 {\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-size: 19px;\n  font-weight: 400;\n}\n\n#login-page .right .right-inductor {\n  position: absolute;\n  width: 70px;\n  height: 7px;\n  background: #fff0;\n  left: 50%;\n  bottom: 70px;\n  transform: translate(-50%, 0%);\n}\n\n#login-page .top_link img {\n  width: 28px;\n  padding-right: 7px;\n  margin-top: -3px;\n}\n\n[class*=sidebar-dark-] .nav-header {\n  background-color: inherit;\n  color: #475259;\n}\n\n[class*=sidebar-dark-] .sidebar a {\n  color: #475259;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n[class*=sidebar-dark-] {\n  background-color: #ffffff;\n}\n\n[class*=sidebar-dark] .brand-link,\n[class*=sidebar-dark] .brand-link .pushmenu {\n  color: #475259;\n}\n\n[class*=sidebar-dark] .brand-link .pushmenu:hover,\n[class*=sidebar-dark] .brand-link:hover {\n  color: #475259;\n}\n\n[class*=sidebar-dark] .brand-link {\n  border-bottom: none;\n}\n\n.elevation-4 {\n  box-shadow: 0 0px 0px rgba(0, 0, 0, .25), 0 0px 5px rgba(0, 0, 0, .22) !important;\n}\n\n.sidebar {\n  padding-left: 0px;\n}\n\n.brand-link .brand-image {\n  float: unset;\n  line-height: .8;\n  margin-left: 0.8rem;\n  margin-right: 0.5rem;\n  margin-top: -3px;\n  max-height: 50px;\n  width: auto;\n}\n\n.nav-pills .nav-link:not(.active):hover {\n  color: #0b1354;\n  background: #e7e7e7;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  color: #0b1354;\n  background-color: #0b135428;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0px 20px 20px 0px !important;\n}\n\ntable {\n  color: #475259 !important;\n  font-size: 14px;\n}\n\n.btn.btn-primary,\n.btn.btn-success,\n.btn-outline-primary:hover,\n.btn-outline-primary:not(:disabled):not(.disabled):active {\n  background: #0b1354;\n  border-color: unset;\n}\n\n.btn-outline-primary {\n  border-color: #0b1354;\n  color: #0b1354;\n}\n\n.btn {\n  border-radius: 20px;\n  padding: 5px 25px;\n}\n\n.bg-primary {\n  background-color: #0b1354 !important;\n}\n\n.btn-primary:not(:disabled):not(.disabled).active,\n.btn-primary:not(:disabled):not(.disabled):active,\n.show>.btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #0b1354;\n  border-color: #0b1354;\n}\n\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 0, 0, .075);\n}\n\n.table-hover>tbody>tr:hover>* {\n  color: #0b1354;\n}\n\n.table thead th {\n  background-color: #fff;\n  color: #0b1354;\n}\n\n.btn.btn-danger {\n  background: #f13776;\n  border-color: unset;\n}\n\n.login img.brand-image {\n  width: 50% !important;\n}\n\n.form-container {\n  text-align: center;\n}\n\np.error {\n  color: #d70149;\n}\n\np.error.hide {\n  display: none;\n}\n\n.form-group {\n  padding: 15px 10px;\n  border: 1px solid #f4f6f9;\n  border-radius: 10px;\n}\n\n.main-sidebar {\n  height: 100vh !important;\n}\n\n\n.thread {\n  padding: 15px 5px;\n}\n\n#records-page .container-fluid {\n  background: #fff;\n}\n\n.border-b {\n  border-bottom: 1px solid #efefef;\n}\n\n.border-t {\n  border-top: 1px solid #efefef;\n}\n\n.border-r {\n  border-right: 1px solid #efefef;\n}\n\n.border-l {\n  border-left: 1px solid #efefef;\n}\n\n.thread {\n  pointer-events: none;\n}\n\n.thread-message.assistant {\n  background: #c0c0c05c;\n}\n\n.thread-message {\n  padding: 5px 10px;\n  margin-bottom: 15px;\n}\n\n.tab-nav .nav-link {\n  color: #475258;\n  font-weight: 600;\n}\n\n.tab-nav .nav-link:hover {\n  color: #0b1354;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.twitter-picker {\n  box-shadow: unset !important;\n}\n\n/* File Uploader Dropper */\n.upload-drop-file svg {\n  display: none !important;\n}\n\n.upload-drop-file {\n  border: 2px dashed rgb(11 19 84 / 24%) !important;\n  border-radius: 3px !important;\n  width: 100% !important;\n    max-width: 100% !important;\n}\n\ntable.table {\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\n/* custom nav bar */\n/* Round Switch Nav Bar */\n\n.round-nav a.nav-link {\n  border-radius: 24px;\n  padding: 5px 25px !important;\n  margin-right: 2px;\n}\n\n.round-nav .border {\n  border: 1px solid #0b1354 !important;\n}\n\n.round-nav .navbar-nav {\n  padding: 5px 7px;\n  border-radius: 40px;\n}\n\n.navbar>.container-fluid.center {\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n}\n\n.card-title {\n  float: unset;\n}\n\n/* Table Custom Design */\n.table-expand-container {\n  padding: 10px 45px;\n}\n\n.table-expand-container .prompt {\n  margin-bottom: 2px;\n  font-weight: bold;\n}\n\ninput.form-control.invalid {\n  border-color: #ee5e3f;\n}\n\n.appearance-image-container {\n  min-height: 250px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  border: 3px #c6c3c3 dotted;\n  border-radius: 5px;\n}\n\n/* EDITOR JS Style */\n.prompt-text-editor {\n  border: 1px solid #dee2e6;\n  border-radius: 20px;\n  padding: 10px 15px;\n}\n\n.cdx-input.embed-tool__caption,\n.inline-image .cdx-input:not([id]) {\n  display: none;\n}\n\niframe.embed-tool__content {\n  width: 100%;\n  border-radius: 10px;\n  height: 30vh !important;\n  min-height: unset !important;\n  max-height: unset !important;\n  background: #fff;\n}\n\n/* REACT DATE RANGE */\n.rdrDateRangePickerWrapper {\n  position: absolute;\n  z-index: 9;\n  width: 100%;\n  padding: 0;\n  margin-top: 5px;\n}\n\n/* Chart Style */\n.text-report p.label {\n  margin: 0;\n  font-size: 12px;\n}\n\n.text-report p.value {\n  text-align: center !important;\n  font-size: 35px;\n  font-weight: 900;\n}\n\n.thread-message img {\n  width: 100%;\n  height: fit-content;\n}\n\nb,\nstrong {\n  text-transform: capitalize;\n}\n\n.badge {\n  text-transform: capitalize;\n}\n\n.input-prompt textarea {\n  width: 100%;\n  height: 50px;\n  border: unset;\n  border-radius: 5px;\n  resize: none;\n  padding: 12px;\n}\n\n.input-prompt textarea:focus-visible {\n  outline: unset\n}\n\n#create-analysis-report .input-prompt {\n  padding: 5px;\n  border: solid 1px #0b135542;\n  border-radius: 5px;\n}\n\nimg.img-assist {\n  width: 100%;\n}\n\n.list-group.menu {\n  width: 100%;\n  padding: 0px 8px;\n}\n\n.list-group.menu button.list-group-item {\n  border: 0;\n  font-weight: 700;\n  border-radius: 10px;\n}\n\n.list-group.menu button.list-group-item.active {\n  background-color: var(--bs-list-group-active-bg-theme);\n}\n\n.list-group.menu button.list-group-item:hover {\n  background-color: var(--bs-list-group-active-hover-theme);\n}\n\n.ca-result-container p {\n  margin-bottom: 20px !important;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n\n.ca-result-container {\n  max-height: 90vh;\n  overflow: auto;\n  height: 90vh;\n  padding-bottom: 15%;\n}\n\n.ca-input-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999999;\n  background: #fff;\n}\n\n\n#create-analysis-report img {\n  width: 100%;\n}\n\n.js-plotly-plot {\n  width: 100%;\n}\n\n\n#create-analysis-report table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n#create-analysis-report table  th,\n#create-analysis-report table  td {\n    border: 1px solid black;\n    padding: 8px;\n    text-align: left;\n}\n\n/* body > iframe {\n  display: none;\n} */\n\n#custom-data-analysis .list-group {\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
